// extracted by mini-css-extract-plugin
export default {"card-secondary":"CardSecondary_card-secondary__1gPMa"};